/**
 * Question publish-state chip — package `StatusBadge` + status-badge-tints.
 *
 * Published is the default state, so showing it on every row is noise. Only
 * Draft is surfaced in cells so authors can spot questions that are not yet
 * live. Filter menus and headers pass `showReady` to label both states.
 */

import { StatusBadge } from "@exxatdesignux/ui/components/status-badge"
import { normalizeQuestionBankStatus, type QuestionBankStatus } from "@/lib/question-bank-status"
import { statusOf } from "@/lib/objects"

export function QuestionBankStatusBadge({
  status,
  size = "sm",
  /** When true, also render Ready (filter menus). Cells leave this off. */
  showReady = false,
  className,
}: {
  status: QuestionBankStatus | string | undefined | null
  /** `sm` for tables / filters; `md` for cards and preview. */
  size?: "sm" | "md"
  showReady?: boolean
  className?: string
}) {
  const normalized = normalizeQuestionBankStatus(status)
  if (normalized === "Published" && !showReady) return null
  // Package gallery: sm = dense table chip (label + tone); md = header/card (+ icon).
  const state = statusOf("question", { id: "", status: normalized })
  const icon = size === "md" ? state.icon : undefined
  return (
    <StatusBadge
      label={state.label}
      tone={state.tone}
      icon={icon}
      size={size}
      className={className}
    />
  )
}
